import React, { useState } from 'react';
import IdentityTabs, { IdentityTabKey } from './IdentityTabs';
import IdentityNetBody from './IdentityNetBody';

// Mock Data Interfaces
interface User {
    name: string;
    empId: string;
    email: string;
    dept: string;
    avatar: string;
    postings: {
        id: number;
        title: string;
        geography: string;
        type: string;
    }[];
}

interface Scope {
    sops: {
        id: number;
        name: string;
        role: string;
        description: string;
        frequency: string;
        lastUpdated?: string;
    }[];
    risks: {
        id: number;
        name: string;
        level: string;
        role: string;
        mitigation: string;
    }[];
    compliances: {
        id: number;
        name: string;
        role: string;
        frequency: string;
        authority: string;
    }[];
}

interface IdentityViewProps {
    user: User;
    scope: Scope;
}

const IdentityView: React.FC<IdentityViewProps> = ({ user, scope }) => {
    const [activeTab, setActiveTab] = useState<IdentityTabKey>('positions');

    return (
        <div className="space-y-6 animate-in slide-in-from-left duration-500">
            <div className="module-page">
                <IdentityTabs
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                    asideOpen={false}
                    onAsideToggle={() => {}}
                />
                <IdentityNetBody
                    activeTab={activeTab}
                    user={user}
                    postings={user.postings}
                    scope={scope}
                    asideOpen={false}
                    onAsideToggle={() => {}}
                />
            </div>
        </div>
    );
};

export default IdentityView;
